import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import ClassDetail from '@/components/ClassDetail.vue';
const classesModule = namespace('classes');
let HandbookClassesDetail = class HandbookClassesDetail extends Vue {
    created() {
        this.fetchClasses();
    }
    get title() {
        return this.className + ' | Handbook' + Vue.prototype.$titleSuffix;
    }
    get classData() {
        return this.classes.find(({ name }) => name === this.className);
    }
};
__decorate([
    classesModule.State
], HandbookClassesDetail.prototype, "classes", void 0);
__decorate([
    classesModule.Action
], HandbookClassesDetail.prototype, "fetchClasses", void 0);
__decorate([
    Prop(String)
], HandbookClassesDetail.prototype, "className", void 0);
HandbookClassesDetail = __decorate([
    Component({
        components: {
            ClassDetail
        }
    })
], HandbookClassesDetail);
export default HandbookClassesDetail;
